/*
  C - WLP Buy Box (sections/c-wlp-buy-box.liquid)
  - Two radios: Subscribe (pack + Recharge plan picked in the select) or Buy
    one time (a fixed variant). Prices are pre-formatted by Liquid in the
    section JSON, so the total always matches checkout.
  - Touching the select also picks Subscribe.
  - Add to cart posts to /cart/add.js (with the selling plan when subscribing)
    and opens the cart drawer through window.cWlpCart (assets/c-wlp-bundle.js).
*/
(() => {
  const initBuyBox = (root) => {
    if (root.dataset.wlpReady === 'true') return;
    root.dataset.wlpReady = 'true';

    const dataEl = root.querySelector('[data-buy-data]');
    if (!dataEl) return;
    const data = JSON.parse(dataEl.textContent);
    const radios = [...root.querySelectorAll('[data-buy-mode]')];
    const select = root.querySelector('[data-buy-plan]');
    const packEl = root.querySelector('[data-buy-pack]');
    const freqEl = root.querySelector('[data-buy-freq]');
    const subPriceEl = root.querySelector('[data-buy-sub-price]');
    const subCompareEl = root.querySelector('[data-buy-sub-compare]');
    const subCompareValueEl = root.querySelector('[data-buy-sub-compare-value]');
    const totalEl = root.querySelector('[data-buy-total]');
    const button = root.querySelector('[data-buy-add]');
    const errorEl = root.querySelector('[data-buy-error]');

    const mode = () => {
      const checked = radios.find((radio) => radio.checked);
      return checked ? checked.value : 'once';
    };
    const subOption = () => (select && data.sub.length ? data.sub[Number(select.value) || 0] : null);

    const render = () => {
      const sub = subOption();
      if (sub) {
        if (packEl) packEl.textContent = sub.pack;
        if (freqEl) freqEl.textContent = sub.freq;
        if (subPriceEl) subPriceEl.textContent = sub.price;
        if (subCompareEl) subCompareEl.hidden = !sub.compare;
        if (subCompareValueEl) subCompareValueEl.textContent = sub.compare;
      }
      const isSub = mode() === 'sub' && sub;
      const pick = isSub ? sub : data.once;
      if (totalEl && pick) totalEl.textContent = pick.price;
      if (button) button.disabled = !pick || !pick.available;
      if (errorEl) errorEl.textContent = pick && !pick.available ? root.dataset.errorText : '';
    };

    const pickSub = () => {
      const subRadio = radios.find((radio) => radio.value === 'sub');
      if (subRadio && !subRadio.checked) subRadio.checked = true;
      render();
    };

    const addToCart = async () => {
      const isSub = mode() === 'sub';
      const pick = isSub ? subOption() : data.once;
      if (!pick || !pick.available) {
        render();
        return;
      }
      const item = { id: pick.variant, quantity: 1 };
      if (isSub && pick.plan) item.selling_plan = pick.plan;

      const cart = window.cWlpCart || {};
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      if (errorEl) errorEl.textContent = '';
      try {
        const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const response = await fetch(`${rootUrl}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [item], sections: cart.getCartSections ? cart.getCartSections() : [] }),
        });
        const payload = await response.json();
        if (!response.ok || payload.status === 422) throw new Error(payload.description || 'add failed');
        if (!(cart.refreshCartUI && cart.refreshCartUI(payload))) window.location.href = root.dataset.cartUrl || '/cart';
      } catch (error) {
        if (errorEl) errorEl.textContent = (error && error.message && error.message !== 'add failed') ? error.message : root.dataset.errorText;
      } finally {
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }
    };

    radios.forEach((radio) => radio.addEventListener('change', render));
    if (select) {
      select.addEventListener('change', pickSub);
      select.addEventListener('focus', pickSub);
    }
    if (button) button.addEventListener('click', addToCart);

    render();
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-wlp-buy]').forEach(initBuyBox);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
